import {InputSearchProps} from "app/Interface/Component/FormInput"
import InputTextController from "app/WebController/Component/Form/InputTextController"
import CloseIcon from "app/WebView/Component/icons/closeIcon"
import React, {useState} from "react"
import {InputGroup} from "react-bootstrap"

function InputSearch({id, value, onChange, focus, ...restProps}: InputSearchProps) {

  const [focusToggle, setFocusToggle] = useState(false)

  return (
    <InputGroup>
      <InputTextController
        id={`search-${id}`}
        value={value}
        onChange={onChange}
        type={'text'}
        focus={focus}
        focusToggle={focusToggle}
        {...restProps}
      />
      <CloseIcon
        id={`clear-search-${id}`}
        variant={'secondary'}
        onClick={() => {
          onChange('')
          setFocusToggle(v => !v)
        }}
      />
    </InputGroup>
  )
}

export default InputSearch
